module.exports = __webpack_public_path__ + "img/nickname.a0c17ea4.svg";